export interface EmailTopicFormValues {
	EmailTopicId: number | null;
	EmailTopicName: string;
	Description: string;
	DelayTimeMinutes: string;
	IsActive: boolean;
	AddressIdsTO: number[];
	AddressIdsCC: number[];
	AddressIdsBCC: number[];
}
export const INITIAL_VALUES: EmailTopicFormValues = {
	EmailTopicId: null,
	EmailTopicName: "",
	Description: "",
	DelayTimeMinutes: "",
	IsActive: true,
	AddressIdsTO: [],
	AddressIdsCC: [],
	AddressIdsBCC: [],
};

export type RecipientField = "AddressIdsTO" | "AddressIdsCC" | "AddressIdsBCC";

export const RECIPIENT_FIELDS: { label: string; field: RecipientField }[] = [
	{ label: "TO", field: "AddressIdsTO" },
	{ label: "CC", field: "AddressIdsCC" },
	{ label: "BCC", field: "AddressIdsBCC" },
];
